import React from 'react';
import { Link } from 'react-router-dom';
import { Copy, ExternalLink, Pencil, Settings2 } from 'lucide-react';
import { Button } from '../ui/button';

export function MemorialOwnerToolbar({
  manageUrl,
  publicUrl,
  onCopyLink,
  onScrollToQr,
}) {
  if (!manageUrl) return null;

  return (
    <div className="memorial-public__owner-bar" data-testid="memorial-owner-toolbar">
      <p>You are previewing your published memorial — visitors see this page without edit controls.</p>
      <div className="flex flex-wrap gap-2">
        <Button size="sm" variant="secondary" className="h-8 rounded-full bg-white/10 text-white hover:bg-white/20" asChild>
          <Link to={manageUrl}>
            <Pencil className="mr-1.5 h-3.5 w-3.5" />
            Edit memorial
          </Link>
        </Button>
        <Button size="sm" variant="secondary" className="h-8 rounded-full bg-white/10 text-white hover:bg-white/20" asChild>
          <Link to={`${manageUrl}#content`}>
            <Settings2 className="mr-1.5 h-3.5 w-3.5" />
            Cover &amp; story
          </Link>
        </Button>
        {publicUrl ? (
          <Button
            type="button"
            size="sm"
            variant="secondary"
            className="h-8 rounded-full bg-white/10 text-white hover:bg-white/20"
            onClick={onCopyLink}
          >
            <Copy className="mr-1.5 h-3.5 w-3.5" />
            Copy link
          </Button>
        ) : null}
        <Button
          type="button"
          size="sm"
          variant="secondary"
          className="h-8 rounded-full bg-white/10 text-white hover:bg-white/20"
          onClick={onScrollToQr}
        >
          <ExternalLink className="mr-1.5 h-3.5 w-3.5" />
          QR &amp; keepsakes
        </Button>
      </div>
    </div>
  );
}

export default MemorialOwnerToolbar;
